import idx from "idx"

/**
 * transform - manipulate data from the graphql query
 * @param {object} ourPeople
 * @returns {object}
 */
function transform(ourPeople) {
  const teams = ourPeople
    ? ourPeople.map(team => {
        const title = idx(team, _ => _.title)
        const people = team.people
          ? team.people.map(person => {
              return {
                photo: idx(person, _ => _.gridPhoto),
                title: idx(person, _ => _.title),
                slug: idx(person, _ => _.slug),
                name: idx(person, _ => _.name),
                content: idx(person, _ => _.content.content)
              }
            })
          : []
        return {
          people,
          title
        }
      })
    : []

  return {
    teams
  }
}

export default { transform }
